import React from "react";
import NavigationDrawer from "../../../components/NavigationDrawer/index";
import { useDispatch, useSelector } from "react-redux";
import { setActiveTab } from "../../../lib/slices/activeTabSlice";
import { Grid } from "@mui/material";
import DynamicTabsDrawer from "../../../components/DynamicTabDrawer";
import Invoices from "./Invoices";
import AllPlans from "./AllPlans";

const tabs = [
  { label: "invoices", value: "invoice" },
  { label: "allSubscriptions", value: "subscription" },
];

function WorkerSubscription() {
  const dispatch = useDispatch();
  // Redux states
  const activeTab = useSelector((state) => state.activeTab.tabs);

  // Function

  const handleChangeTab = (tab) => {
    dispatch(setActiveTab({ ...activeTab, subscription: tab }));
  };

  return (
    <NavigationDrawer>
      <Grid container spacing={1}>
        <Grid item xs={12} md={2.3}>
          <DynamicTabsDrawer
            primaryHeading={"plans"}
            tabs={tabs}
            activeTab={activeTab.subscription}
            handleChangeTab={handleChangeTab}
          />
        </Grid>
        <Grid item xs={12} md={9.7}>
          {activeTab.subscription === "invoice" ? <Invoices /> : <AllPlans />}
        </Grid>
      </Grid>
    </NavigationDrawer>
  );
}

export default WorkerSubscription;
